import { Button } from "@hisani/ui";
import { Search } from "lucide-react";
import React from "react";

export function MarketplaceLoadingGrid({ label }: { readonly label: string }) {
  return (
    <div
      role="status"
      aria-label={label}
      className="grid gap-5 md:grid-cols-2 min-[1200px]:grid-cols-3"
    >
      {[0, 1, 2].map((item) => (
        <div
          key={item}
          className="overflow-hidden rounded-lg border border-border-subtle bg-surface shadow-[var(--elevation-1)]"
        >
          <div className="aspect-[2/1] animate-pulse bg-subtle motion-reduce:animate-none" />
          <div className="grid gap-3 p-5">
            <div className="h-5 w-2/3 animate-pulse rounded-sm bg-subtle motion-reduce:animate-none" />
            <div className="h-4 w-1/2 animate-pulse rounded-sm bg-subtle motion-reduce:animate-none" />
            <div className="h-8 w-1/3 animate-pulse rounded-sm bg-subtle motion-reduce:animate-none" />
          </div>
        </div>
      ))}
    </div>
  );
}

export function MarketplaceEmptyState({
  title,
  body,
  action,
  onAction,
}: {
  readonly title: string;
  readonly body: string;
  readonly action?: string;
  readonly onAction?: () => void;
}) {
  return (
    <div className="rounded-lg border border-dashed border-border-default bg-surface p-8 text-center sm:p-12">
      <Search className="mx-auto size-8 text-brand-ink" aria-hidden="true" />
      <h3 className="mt-4 text-xl font-bold">{title}</h3>
      <p className="mx-auto mt-2 max-w-md text-sm leading-6 text-secondary">
        {body}
      </p>
      {action === undefined || onAction === undefined ? null : (
        <Button
          type="button"
          variant="secondary"
          className="mt-5"
          onClick={onAction}
        >
          {action}
        </Button>
      )}
    </div>
  );
}
